import recall from './recall.js';
import useAsync from './useAsync.js';
import useAsyncSafe from './useAsyncSafe.js';
export function constructor(methods) {
    return function create(func, config) {
        return methods.map((method) => (...args) => method(func, config, args));
    };
}
export default constructor([
    useAsync,
    recall,
    useAsyncSafe,
]);
//# sourceMappingURL=create.js.map